import {
    AGENTS_UPDATED,
    BDS_UPDATED,
    CLIENTS_UPDATED,
    CUSTODIANS_UPDATED,
    GET_AGENTS,
    GET_AGENTS_ERROR,
    GET_BDS,
    GET_BDS_ERROR,
    GET_CLIENTS,
    GET_CLIENTS_ERROR,
    GET_CUSTODIANS,
    GET_CUSTODIANS_ERROR,
    GET_GROUPS,
    GET_GROUPS_ERROR,
    GET_RIAS,
    GET_RIAS_ERROR,
    GROUPS_UPDATED,
    RIAS_UPDATED
} from "./actionTypes";

export const custodiansUpdated = custodian => {
    return {
        type: CUSTODIANS_UPDATED,
        payload: custodian
    };
};

export const getCustodiansAction = () => {
    return {
        type: GET_CUSTODIANS,
        payload: {}
    };
};

export const getCustodiansError = error => {
    return {
        type: GET_CUSTODIANS_ERROR,
        payload: error
    };
};

export const bdsUpdated = bd => {
    return {
        type: BDS_UPDATED,
        payload: bd
    };
};

export const getBdsAction = () => {
    return {
        type: GET_BDS,
        payload: {}
    };
};

export const getBdsError = error => {
    return {
        type: GET_BDS_ERROR,
        payload: error
    };
};

export const riasUpdated = ria => {
    return {
        type: RIAS_UPDATED,
        payload: ria
    };
};

export const getRiasAction = () => {
    return {
        type: GET_RIAS,
        payload: {}
    };
};

export const getRiasError = error => {
    return {
        type: GET_RIAS_ERROR,
        payload: error
    };
};

export const agentsUpdated = agent => {
    return {
        type: AGENTS_UPDATED,
        payload: agent
    };
};

export const getAgentsAction = () => {
    return {
        type: GET_AGENTS,
        payload: {}
    };
};

export const getAgentsError = error => {
    return {
        type: GET_AGENTS_ERROR,
        payload: error
    };
};

export const clientsUpdated = client => {
    return {
        type: CLIENTS_UPDATED,
        payload: client
    };
};

export const getClientsAction = () => {
    return {
        type: GET_CLIENTS,
        payload: {}
    };
};

export const getClientsError = error => {
    return {
        type: GET_CLIENTS_ERROR,
        payload: error
    };
};

export const groupsUpdated = group => {
    return {
        type: GROUPS_UPDATED,
        payload: group
    };
};

export const getGroupsAction = () => {
    return {
        type: GET_GROUPS,
        payload: {}
    };
};

export const getGroupsError = error => {
    return {
        type: GET_GROUPS_ERROR,
        payload: error
    };
};
